<template>
  <div class="container mt-4 mb-4">
    <div class="row">
      <div class="col-12">
        <div :class="[{ 'no-card': disableCard }]">
          <div :class="['card-body', { 'no-card': disableCard }]">
            <div :class="[{'content-box content-box-plus': !disableCard}, { 'no-card': disableCard }]">
              <div class="m-2 text-center" v-show="isLoading">
                <font-awesome-icon
                  :icon="['fa', 'circle-notch']"
                  class="fa-spin m-auto spinner fa-5x egx-partner-color"
                />
              </div>
              <div :class="['card-body', { 'no-card': disableCard }]" v-if="!isLoading">
                <div class="row">
                  <div class="col-12">
                    <div class="title">
                      <span class="step-title mb-4" v-html="pageConfiguration.title" />
                    </div>
                    <div class="step-description" v-html="pageConfiguration.main_instructions" v-if="pageConfiguration.main_instructions"/>
                  </div>
                </div>
                <ProjectMeasuresList
                  :projectId="projectId" 
                  :measuresButton="pageConfiguration.measurecart.buttons"
                  :navigate="handleRedirectBack"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectMeasuresList from '../components/project/ProjectMeasuresList.vue';
import projectMixins from '@/shared/mixins/projectMixins';


export default {
  components: {
    ProjectMeasuresList,
  },
  mixins: [projectMixins],
  data() {
    return {
      disableCard: false,
      projectId: this.$route.params.id,
      isLoading: false,
      pageConfiguration: {},
    };
  },

  created() {
    this.isLoading = true;
    if (this.locked(this.currentProject)) {
      this.$router.push('/applications');
    }
    this.$store.dispatch('fulfill_integrate/getPageConfiguration', {
      task_name: 'measurecart',
      project_id: this.$route.params.id,
    })
    .then((response) => {
      this.pageConfiguration = response;
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.isLoading = false;
    });
  },

  computed: {
    currentProject() {
      return this.$store.state.fulfill_integrate.project
    },
  },

  methods: {
    handleRedirectBack() {
      const savedPage = localStorage.getItem('currentPage');
      if (savedPage && savedPage !== this.$route.fullPath) {
        this.$router.push(savedPage);
        return;
      }
    }
  },
}
</script>
<style scoped>
#application-wrapper .content-box {
  margin: auto;
  overflow: visible;
}
.row {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}
</style>
